import React from "react";
import QuickSightDashboardWidget from "./widgets/dashboard.widget";
import "../../../scss/dashboard.scss";
import { useGetQuickSightOrg } from "./hooks";
import { useStateContext } from "state";
import { Navigate } from "react-router-dom";
import paths from "paths";

export const DashboardPage: React.FC = () => {
    const state = useStateContext();
    const result = useGetQuickSightOrg();

    if (state.user?.isSingleAdHocAccount) {
        return <Navigate to={`/${paths.authenticated.PROJECTS}`} />
    }

    return <QuickSightDashboardWidget data={result.data?.embed_url} isLoading={result.isLoading} isError={result.isError} error={result.error} />
}
